import CartButton from '@components/cart/CartButton';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useShop from '@hooks/shop/useShop';
import useGoBack from '@hooks/useGoBack';
import useProject from '@hooks/useProject';
import ArrowLineLeft from '@icons/arrow/ArrowLineLeft';
import { useFlow } from '@router/stackflow';

interface Props {
    shopId: string;
}

function ItemHeader({ shopId }:Props) {
  const goBack = useGoBack();
  const shop = useShop(shopId);
  const project = useProject();
  return (
        <Wrapper>
            <Container>
                <Row>
                    <ArrowLineLeft size={30}
                                   onClick={goBack}
                                   color={colors.gray9}/>
                    <Row spacing={8} fullWidth css={css`
                        flex: 1;
                        padding-right: 8px;
                    `}>
                        <Text color={colors.gray9} size='lg' as='span'
                        css={css`
                            width: auto;
                            padding: 0;
                            overflow: hidden;
                            word-break: break-all;
                        `}>
                            <b>{shop?.name}</b>
                            에서 주문합니다
                        </Text>
                    </Row>
                </Row>
                {project?.features.orderEnabled && (
                    <CartButton shopId={shopId} />
                )}
            </Container>
        </Wrapper>
  );
}

const Wrapper = styled.div`
    background-color: var(--color-white);
    height: calc(66px + var(--safe-area-top));
    left: 0;
    padding: calc(18px + var(--safe-area-top)) 18px 18px;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 10;
`;

const Container = styled.nav`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: space-between;
    position: relative;
    width: 100%;
`;

export default ItemHeader;
